import React from "react";

export const DEFAULT_LEVELS = [
  {
    value: 1,
    label: "ضعيفة",
    title: "ضعيف",
    description: "رأي غير مرتبط بالنص، يفتقر للمنطق او التبرير.",
    color: "#ff8a8a",
  },
  {
    value: 2,
    label: "محدودة",
    title: "محدود",
    description: "إجابة مقبولة إلى حد ما، لكنها تفتقر إلى التفاصيل.",
    color: "#fb923c",
  },
  {
    value: 3,
    label: "جيدة",
    title: "جيد",
    description: "إجابة جيدة ومرتبطة بالنص بشكل مناسب.",
    color: "#facc15",
  },
  {
    value: 4,
    label: "ممتازة",
    title: "ممتاز",
    description: "إجابة شاملة ومفصلة وتعكس فهماً عميقاً للنص.",
    color: "#4ade80",
  },
];

const EvaluationSlider = ({
  score = 0,
  isEditable = false,
  onScoreChange,
  onFeedbackChange,
  levels = DEFAULT_LEVELS,
  title = "",
  showDescriptionOnly = false,
}) => {
  const currentLevelIndex = levels.findIndex(
    (level, idx) =>
      (level.value !== undefined ? level.value : idx) === Number(score),
  );
  const safeIndex = currentLevelIndex !== -1 ? currentLevelIndex : 0;
  const currentLevel = levels[safeIndex] || levels[0];

  const activeColor = currentLevel?.color;
  const sliderBackground = `linear-gradient(to left, ${levels.map((level) => level.color || "#fb923c").join(", ")})`;
  const displayedDescription = currentLevel?.description;

  return (
    <div
      className="evaluation-slider-widget"
      style={{ fontFamily: "inherit", "--thumb-border-color": activeColor }}
    >
      {title && (
        <div
          className="text-center mb-4 fw-bold"
          style={{ color: "#4a4a4a", fontSize: 14 }}
        >
          {title}
        </div>
      )}

      <div className="px-2 mb-4">
        <div className="position-relative mb-2" style={{ padding: "0 12px" }}>
          <input
            type="range"
            dir="rtl"
            className="custom-evaluation-slider"
            min={0}
            max={levels.length - 1}
            value={safeIndex}
            onChange={(e) => {
              const idx = parseInt(e.target.value, 10);
              const selectedLevel = levels[idx];
              const val =
                selectedLevel?.value !== undefined ? selectedLevel.value : idx;
              isEditable && onScoreChange?.(val, selectedLevel);
            }}
            disabled={!isEditable}
            style={{
              width: "100%",
              height: 8,
              borderRadius: 4,
              background: sliderBackground,
              outline: "none",
              WebkitAppearance: "none",
              appearance: "none",
              cursor: isEditable ? "pointer" : "default",
              pointerEvents: isEditable ? "auto" : "none",
              margin: 0,
            }}
          />
        </div>
        <div
          className="position-relative mt-3"
          style={{ height: 24, margin: "0 12px" }}
        >
          {levels.map((level, idx) => {
            const isActive = safeIndex === idx;
            return (
              <span
                key={idx}
                onClick={() => {
                  const val = level.value !== undefined ? level.value : idx;
                  isEditable && onScoreChange?.(val, level);
                }}
                style={{
                  position: "absolute",
                  right: `${levels.length > 1 ? (idx / (levels.length - 1)) * 100 : 0}%`,
                  transform: "translateX(50%)",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  color: isActive ? activeColor : "#a0a0a0",
                  fontWeight: isActive ? "bold" : "normal",
                  fontSize: 13,
                  cursor: isEditable ? "pointer" : "default",
                  pointerEvents: isEditable ? "auto" : "none",
                  transition: "color 0.2s ease, font-weight 0.2s ease",
                }}
              >
                {level.label}
              </span>
            );
          })}
        </div>
      </div>

      <div
        className="p-3 border mt-4 text-end"
        style={{
          borderRadius: 8,
          borderColor: activeColor,
          backgroundColor: activeColor + "12",
          minHeight: 80,
          direction: "rtl",
          transition: "background-color 0.2s ease, border-color 0.2s ease",
        }}
      >
        {isEditable && !showDescriptionOnly ? (
          <textarea
            className="form-control border-0 bg-transparent p-0 w-100 text-end"
            style={{
              boxShadow: "none",
              resize: "none",
              minHeight: 60,
              color: "#242424",
              fontSize: 14,
              lineHeight: 1.6,
            }}
            value={displayedDescription}
            onChange={(e) => isEditable && onFeedbackChange?.(e.target.value)}
            placeholder="أضف تعليقاً..."
          />
        ) : (
          <div>
            <div
              className="fw-bold mb-1"
              style={{ color: activeColor, fontSize: 14 }}
            >
              {currentLevel.title || currentLevel.label}
            </div>
            <div style={{ color: "#4a4a4a", fontSize: 13, lineHeight: 1.6 }}>
              {displayedDescription}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EvaluationSlider;
